import Vue from "vue";
import Vuex from "vuex";
import vuexI18n from "vuex-i18n";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    preview: true,
    // Editable site settings served by the menu/admin node server (/settings).
    settings: {
      phone: "+381 66 404049",
      happyHour: { enabled: false, text: { sr: "", en: "", ru: "" } }
    }
  },
  mutations: {
    ["TOOGLE_PREV"](state) {
      state.preview = false;
    },
    ["SET_SETTINGS"](state, settings) {
      state.settings = settings;
    }
  },
  actions: {
    changePreview({ commit }) {
      commit("TOOGLE_PREV");
    },
    async fetchSettings({ commit }) {
      try {
        const res = await fetch("/settings");
        if (!res.ok) return;
        const s = await res.json();
        commit("SET_SETTINGS", {
          phone: s.phone || "+381 66 404049",
          happyHour: {
            enabled: !!(s.happyHour && s.happyHour.enabled),
            text: (s.happyHour && s.happyHour.text) || { sr: "", en: "", ru: "" }
          }
        });
      } catch (e) {
        // keep defaults if the settings endpoint is unreachable
      }
    }
  },
  modules: {}
});

Vue.use(vuexI18n.plugin, store);

export default store;
